// removed by extract-text-webpack-plugin
module.exports = {"block":"CollapsibleTextBlock__block-3NcW9","showMoreBtn":"CollapsibleTextBlock__showMoreBtn-248f8","isExpand":"CollapsibleTextBlock__isExpand-3bnEL"};